import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  /* min-width: 800px; */

  margin: 0 auto;
  width: 900px;
  height: 500px;
  bottom: 5rem;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};

  border-radius: 16px;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .close {
    border: none;
    background: none;

    width: 40px;
    height: 40px;

    svg {
      path {
        stroke: rgb(${({ theme }) => theme.excerpt.primary});
      }
    }
  }

  h2 {
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    color: #ff6600;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  h1 {
    font-family: Montserrat;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    /* margin-right: 274px; */
  }

  button {
    position: absolute;
    right: 0;
    margin-right: 32px;
  }
`
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
  /* padding-left: 42px; */
  line-height: 143%;
  gap: 10rem;
`

export const NavigationQuestion = styled.div`
  .previusQuestion {
    margin-left: 6px;
  }
`
export const OtherCourses = styled.div`
  .activateSubject {
    margin-left: 20px;
  }
`

export const ResolutionQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 2rem;
  margin-left: 3rem;
`

export const TextIcons = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 15px;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  margin-top: 10px;
  color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#4A4A4A')};

  .previusQuestion {
    margin
  }
`

export const ShortCutNumber = styled.div`
  width: 36.152px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid var(--neutral-gray-200, #bababa);
  color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#4A4A4A')};
  background-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#E3E3E3')};
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  padding-top: 4px;
`

export const ShortCutLetter = styled.div`
  width: 106.152px;
  height: 30px;
  border-radius: 2px;
  color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#4A4A4A')};k
  border: 1px solid var(--neutral-gray-200, #bababa);
  background-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#E3E3E3')};
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  padding-top: 5px;
`

export const Resource = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-size: 13px;
  font-weight: 500;
`
